import { createStore, applyMiddleware, combineReducers } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import thunkMiddleware from 'redux-thunk';
import { authTypes, marketplaceInviteTypes, campaignTypes } from '@actions';
import { addToList } from '@dotone/react-ui-core/utils';
import { affiliateInviteStatuses } from '@dotone/react-ui-core/constants';
import * as RootReducers from './reducers';

const bindMiddleware = (middleware) => applyMiddleware(...middleware);

const combinedReducer = combineReducers(RootReducers);

const reducer = (state, action) => {
  let nextState = { ...state };

  if (action.type === authTypes.DEAUTH) {
    return combinedReducer(undefined, action);
  }

  if (action.type === marketplaceInviteTypes.CREATE.SUCCESS) {
    const { offerId, affiliateId } = action.payload.data;

    nextState = {
      ...nextState,
      affiliateMarketSearch: {
        ...nextState.affiliateMarketSearch,
        data: addToList(nextState.affiliateMarketSearch.data, action.payload.data.affiliate),
      },
      marketplaceInviteList: {
        ...nextState.marketplaceInviteList,
        data: nextState.marketplaceInviteList.data.map((item) => {
          if (
            item.offerId === offerId &&
            item.affiliateId === affiliateId &&
            item.status === affiliateInviteStatuses.EXPIRED &&
            item.reinvitable
          ) {
            // update all expired reinvitable
            return {
              ...item,
              reinvitable: false,
            };
          }

          return item;
        }),
      },
    };
  }

  if (action.type === campaignTypes.UPDATE.SUCCESS) {
    const affiliate = nextState.affiliateList.data.find(
      (item) => item.id === action.payload.data.affiliate.id
    );

    nextState = {
      ...nextState,
      affiliateList: {
        ...nextState.affiliateList,
        data: addToList(nextState.affiliateList.data, {
          ...affiliate,
          campaigns: addToList(affiliate.campaigns, action.payload.data),
        }),
      },
      campaignUpdate: {
        ...nextState.campaignUpdate,
        isLoading: false,
      },
    };
  }

  return combinedReducer(nextState, action);
};

const initStore = () => createStore(reducer, bindMiddleware([thunkMiddleware]));

const wrapper = createWrapper(initStore);

export default wrapper;
